import React, { FC } from "react";

import Form from "react-bootstrap/Form";

import { ReactMultiEmail, isEmail } from "react-multi-email";

import "react-multi-email/dist/style.css";

 

const MultiEmailSelect = ({

  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  disabled,
  setFieldValue,

}) => {

  return (

    <Form.Group className="mb-3 pb-1" controlId={controlId}>

      <Form.Label className="mb-1 text-uppercase fs-11 fw-bold label-color ls-small">

        {label}

      </Form.Label>

 

      <div className="position-relative">

        <ReactMultiEmail

          className={errorsField ? "form-control p-1 is-invalid" : ""}

          placeholder="Email Addresses"

          emails={value}

          onChange={(_emails) => {

            setFieldValue("emails", _emails);

          }}

          //   onChange={handleChange}

          // autoFocus={true}

          //   onFocus={() => setFocused(true)}

          //   onBlur={() => setFocused(false)}

          onBlur={handleBlur}

          getLabel={(email, index, removeEmail) => {

            return (

              <div data-tag key={index}>

                <div data-tag-item>{email}</div>

                <span data-tag-handle onClick={() => removeEmail(index)}>

                  ×

                </span>

              </div>

            );

          }}

        />

 

        {/* <Form.Control

          value={value}

          type="text"

          placeholder={placeholder}

          onBlur={handleBlur}

          onChange={handleChange}

          isInvalid={!!errorsField && touched}

          disabled={disabled}

        /> */}

 

        <div className="invalid-feedback d-block">{errorsField}</div>

      </div>

    </Form.Group>

  );

};

 

export default MultiEmailSelect;

 